import React from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import ResetPasswordView from '../components/ResetPasswordView';
import '../assets/style.scss';

const ResetPassword = props => {
  const {match} = props;

  return (
    <div className="public-layout">
      <div className="login-layout">
        <ResetPasswordView {...props} token={match.params.token} />
      </div>
    </div>
  );
};

ResetPassword.propTypes = {
  t: PropTypes.func,
  match: PropTypes.object,
};

export default withTranslation('login')(ResetPassword);
